module.exports = __webpack_public_path__ + "static/media/personalities_feature.f1f0950b.png";